import { LottieBase, LottieProps } from './lottie-base';

const animationJSON = {
  nm: 'ic-flame_sm',
  v: '5.9.6',
  fr: 30,
  ip: 0,
  op: 45,
  w: 20,
  h: 20,
  ddd: 0,
  markers: [],
  assets: [],
  layers: [
    {
      ty: 3,
      ddd: 0,
      ind: 13506,
      hd: false,
      nm: 'ic-flame_sm - Null',
      ks: {
        a: { a: 0, k: [0, 0] },
        o: { a: 0, k: 100 },
        p: { a: 0, k: [0, 0] },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 3,
      ddd: 0,
      ind: 69444,
      hd: false,
      nm: 'Vector - Null',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        o: { a: 0, k: 100 },
        p: { a: 0, k: [10.8333, 11.6667] },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 52322,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ddd: 0,
      ind: 58786,
      hd: false,
      nm: 'Vector - Stroke',
      parent: 69444,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      ty: 4,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: false,
              v: [
                [2.4981, 0],
                [1.8081, 1.7268],
                [0, 2.5],
              ],
              i: [
                [0, 0],
                [0.4682, -0.4686],
                [0.6897, -0.0266],
              ],
              o: [
                [0.02638000000000007, 0.63726],
                [-0.4682299999999999, 0.46858999999999984],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'st',
          o: { a: 0, k: 100 },
          w: { a: 0, k: 1.5 },
          c: { a: 0, k: [0.996078431372549, 0.7607843137254902, 0.25882352941176473] },
          ml: 0,
          lc: 2,
          lj: 2,
          nm: 'Stroke',
          hd: false,
        },
      ],
      tt: 1,
    },
    {
      ty: 3,
      ddd: 0,
      ind: 55105,
      hd: false,
      nm: 'Vector 11 - Null',
      parent: 13506,
      ks: {
        a: { a: 0, k: [6.075, 14.6623] },
        o: {
          a: 1,
          k: [
            { t: 0, s: [100], o: { x: [0], y: [0] }, i: { x: [0.58], y: [1] } },
            { t: 22.5, s: [80], o: { x: [0.42], y: [0] }, i: { x: [1], y: [1] } },
            { t: 45, s: [100] },
          ],
        },
        p: { a: 0, k: [10.2531, 17.5128] },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 95005,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ddd: 0,
      ind: 91972,
      hd: false,
      nm: 'Vector 11 - Stroke',
      parent: 55105,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            { t: 0, s: [100], o: { x: [0], y: [0] }, i: { x: [0.58], y: [1] } },
            { t: 22.5, s: [80], o: { x: [0.42], y: [0] }, i: { x: [1], y: [1] } },
            { t: 45, s: [100] },
          ],
        },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      ty: 4,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 1,
            k: [
              {
                t: 0,
                s: [
                  {
                    c: true,
                    v: [
                      [2.5548, 0.0661],
                      [8.7836, 4.6495],
                      [11.3484, 4.2328],
                      [8.5479, 14.2415],
                      [0.5732, 11.3493],
                      [1.0423, 5.5648],
                      [2.1884, 7.5662],
                      [4.7532, 6.7329],
                      [2.5548, 0.0662],
                      [2.5548, 0.0661],
                    ],
                    i: [
                      [0, 0],
                      [-1.5791, -3.6651],
                      [-0.7328, 1.6667],
                      [3.1669, -1.2586],
                      [0.9383, 2.4102],
                      [-0.8999, 1.0101],
                      [-0.9287, -0.6431],
                      [-0.4929, 0.8899],
                      [2.7061, 3.3942],
                      [0, 0],
                    ],
                    o: [
                      [1.3169399999999998, -0.39006],
                      [0.7460100000000001, 1.73151],
                      [1.8320100000000004, 4.58336],
                      [-3.1669400000000003, 1.2586200000000005],
                      [-1.10191, -2.8306199999999997],
                      [0.43618, -0.48958999999999975],
                      [0.92869, 0.6430699999999998],
                      [0.4928699999999999, -0.8898900000000003],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [
                  {
                    c: true,
                    v: [
                      [3.1343, 2.4688],
                      [8.3378, 6.2977],
                      [10.4804, 5.9496],
                      [8.1409, 14.3107],
                      [1.4789, 11.8946],
                      [1.8708, 7.0623],
                      [2.8282, 8.7342],
                      [4.9708, 8.038],
                      [3.1343, 2.4688],
                      [3.1343, 2.4688],
                    ],
                    i: [
                      [0, 0],
                      [-1.3192, -3.0618],
                      [-0.6122, 1.3923],
                      [2.6456, -1.0514],
                      [0.7838, 2.0135],
                      [-0.7518, 0.8439],
                      [-0.7758, -0.5372],
                      [-0.4117, 0.7434],
                      [2.2607, 2.8354],
                      [0, 0],
                    ],
                    o: [
                      [1.1001600000000002, -0.32585],
                      [0.6232100000000003, 1.4464800000000002],
                      [1.5304400000000005, 3.82888],
                      [-2.6456300000000006, 1.0514299999999999],
                      [-0.92053, -2.3646700000000003],
                      [0.36438000000000015, -0.4089999999999998],
                      [0.77582, 0.5372199999999996],
                      [0.41174, -0.7434099999999999],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              {
                t: 45,
                s: [
                  {
                    c: true,
                    v: [
                      [2.5548, 0.0661],
                      [8.7836, 4.6495],
                      [11.3484, 4.2328],
                      [8.5479, 14.2415],
                      [0.5732, 11.3493],
                      [1.0423, 5.5648],
                      [2.1884, 7.5662],
                      [4.7532, 6.7329],
                      [2.5548, 0.0662],
                      [2.5548, 0.0661],
                    ],
                    i: [
                      [0, 0],
                      [-1.5791, -3.6651],
                      [-0.7328, 1.6667],
                      [3.1669, -1.2586],
                      [0.9383, 2.4102],
                      [-0.8999, 1.0101],
                      [-0.9287, -0.6431],
                      [-0.4929, 0.8899],
                      [2.7061, 3.3942],
                      [0, 0],
                    ],
                    o: [
                      [1.3169399999999998, -0.39006],
                      [0.7460100000000001, 1.73151],
                      [1.8320100000000004, 4.58336],
                      [-3.1669400000000003, 1.2586200000000005],
                      [-1.10191, -2.8306199999999997],
                      [0.43618, -0.48958999999999975],
                      [0.92869, 0.6430699999999998],
                      [0.4928699999999999, -0.8898900000000003],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
              },
            ],
          },
        },
        {
          ty: 'gs',
          o: { a: 0, k: 100 },
          w: { a: 0, k: 1.5 },
          g: {
            p: 2,
            k: {
              a: 0,
              k: [
                0, 0.9764705882352941, 0.1568627450980392, 0.1568627450980392, 1,
                0.996078431372549, 0.8352941176470589, 0.27058823529411763, 0, 1, 1, 1,
              ],
            },
          },
          s: {
            a: 1,
            k: [
              {
                t: 0,
                s: [12.150005914230514, -0.821330146114773],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [10.150004940694627, -0.6861288174922092],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              { t: 45, s: [12.150005914230514, -0.821330146114773] },
            ],
          },
          e: {
            a: 1,
            k: [
              {
                t: 0,
                s: [12.150005914230514, 13.888045034987917],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [10.150004940694627, 11.601897193486458],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              { t: 45, s: [12.150005914230514, 13.888045034987917] },
            ],
          },
          t: 1,
          lc: 2,
          lj: 2,
          ml: 0,
          nm: 'Stroke',
          hd: false,
        },
      ],
      tt: 1,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 45329,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 62073,
      hd: false,
      nm: 'Vector 11',
      parent: 55105,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            { t: 0, s: [100], o: { x: [0], y: [0] }, i: { x: [0.58], y: [1] } },
            { t: 22.5, s: [80], o: { x: [0.42], y: [0] }, i: { x: [1], y: [1] } },
            { t: 45, s: [100] },
          ],
        },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 1,
            k: [
              {
                t: 0,
                s: [
                  {
                    c: true,
                    v: [
                      [2.5548, 0.0661],
                      [8.7836, 4.6495],
                      [11.3484, 4.2328],
                      [8.5479, 14.2415],
                      [0.5732, 11.3493],
                      [1.0423, 5.5648],
                      [2.1884, 7.5662],
                      [4.7532, 6.7329],
                      [2.5548, 0.0662],
                      [2.5548, 0.0661],
                    ],
                    i: [
                      [0, 0],
                      [-1.5791, -3.6651],
                      [-0.7328, 1.6667],
                      [3.1669, -1.2586],
                      [0.9383, 2.4102],
                      [-0.8999, 1.0101],
                      [-0.9287, -0.6431],
                      [-0.4929, 0.8899],
                      [2.7061, 3.3942],
                      [0, 0],
                    ],
                    o: [
                      [1.3169399999999998, -0.39006],
                      [0.7460100000000001, 1.73151],
                      [1.8320100000000004, 4.58336],
                      [-3.1669400000000003, 1.2586200000000005],
                      [-1.10191, -2.8306199999999997],
                      [0.43618, -0.48958999999999975],
                      [0.92869, 0.6430699999999998],
                      [0.4928699999999999, -0.8898900000000003],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [
                  {
                    c: true,
                    v: [
                      [3.1343, 2.4688],
                      [8.3378, 6.2977],
                      [10.4804, 5.9496],
                      [8.1409, 14.3107],
                      [1.4789, 11.8946],
                      [1.8708, 7.0623],
                      [2.8282, 8.7342],
                      [4.9708, 8.038],
                      [3.1343, 2.4688],
                      [3.1343, 2.4688],
                    ],
                    i: [
                      [0, 0],
                      [-1.3192, -3.0618],
                      [-0.6122, 1.3923],
                      [2.6456, -1.0514],
                      [0.7838, 2.0135],
                      [-0.7518, 0.8439],
                      [-0.7758, -0.5372],
                      [-0.4117, 0.7434],
                      [2.2607, 2.8354],
                      [0, 0],
                    ],
                    o: [
                      [1.1001600000000002, -0.32585],
                      [0.6232100000000003, 1.4464800000000002],
                      [1.5304400000000005, 3.82888],
                      [-2.6456300000000006, 1.0514299999999999],
                      [-0.92053, -2.3646700000000003],
                      [0.36438000000000015, -0.4089999999999998],
                      [0.77582, 0.5372199999999996],
                      [0.41174, -0.7434099999999999],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              {
                t: 45,
                s: [
                  {
                    c: true,
                    v: [
                      [2.5548, 0.0661],
                      [8.7836, 4.6495],
                      [11.3484, 4.2328],
                      [8.5479, 14.2415],
                      [0.5732, 11.3493],
                      [1.0423, 5.5648],
                      [2.1884, 7.5662],
                      [4.7532, 6.7329],
                      [2.5548, 0.0662],
                      [2.5548, 0.0661],
                    ],
                    i: [
                      [0, 0],
                      [-1.5791, -3.6651],
                      [-0.7328, 1.6667],
                      [3.1669, -1.2586],
                      [0.9383, 2.4102],
                      [-0.8999, 1.0101],
                      [-0.9287, -0.6431],
                      [-0.4929, 0.8899],
                      [2.7061, 3.3942],
                      [0, 0],
                    ],
                    o: [
                      [1.3169399999999998, -0.39006],
                      [0.7460100000000001, 1.73151],
                      [1.8320100000000004, 4.58336],
                      [-3.1669400000000003, 1.2586200000000005],
                      [-1.10191, -2.8306199999999997],
                      [0.43618, -0.48958999999999975],
                      [0.92869, 0.6430699999999998],
                      [0.4928699999999999, -0.8898900000000003],
                      [0, 0],
                      [0, 0],
                    ],
                  },
                ],
              },
            ],
          },
        },
        {
          ty: 'gf',
          o: { a: 0, k: 100 },
          g: {
            p: 2,
            k: {
              a: 0,
              k: [
                0, 1, 0.7607843137254902, 0.6235294117647059, 1, 1, 0.9725490196078431,
                0.8745098039215686, 0, 1, 1, 1,
              ],
            },
          },
          s: {
            a: 1,
            k: [
              {
                t: 0,
                s: [11.66843051765191, -2.850587102247852],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [9.747701214334722, -2.3813444165856152],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              { t: 45, s: [11.66843051765191, -2.850587102247852] },
            ],
          },
          e: {
            a: 1,
            k: [
              {
                t: 0,
                s: [11.668430517652133, 10.649418943127587],
                o: { x: [0], y: [0] },
                i: { x: [0.58], y: [1] },
              },
              {
                t: 22.5,
                s: [9.74770121433491, 8.896389912134309],
                o: { x: [0.42], y: [0] },
                i: { x: [1], y: [1] },
              },
              { t: 45, s: [11.668430517652133, 10.649418943127587] },
            ],
          },
          t: 1,
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      ef: [],
      tt: 1,
    },
    {
      ty: 3,
      ddd: 0,
      ind: 24562,
      hd: false,
      nm: 'Ellipse 11 - Null',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0.75, 0.75] },
        o: {
          a: 1,
          k: [
            { t: 26.1, s: [100], o: { x: [0.5], y: [0] }, i: { x: [0.5], y: [1] } },
            { t: 43.8, s: [0] },
          ],
        },
        p: {
          a: 1,
          k: [
            {
              t: 18.6,
              s: [13.75, 13.5833],
              o: { x: [0.5], y: [0] },
              i: { x: [0.5], y: [1] },
              ti: [0, 0],
              to: [0, 0],
            },
            { t: 43.79999999999999, s: [13.75, -0.9199999999999999] },
          ],
        },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 53176,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 76078,
      hd: false,
      nm: 'Ellipse 11',
      parent: 24562,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            { t: 26.1, s: [100], o: { x: [0.5], y: [0] }, i: { x: [0.5], y: [1] } },
            { t: 43.8, s: [0] },
          ],
        },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [1.5, 0.75],
                [1.4633, 0.9818],
                [1.3568, 1.1909],
                [1.1909, 1.3568],
                [0.9818, 1.4633],
                [0.75, 1.5],
                [0.5183, 1.4633],
                [0.3092, 1.3568],
                [0.1433, 1.1909],
                [0.0367, 0.9818],
                [0, 0.75],
                [0.0367, 0.5183],
                [0.1433, 0.3092],
                [0.3092, 0.1433],
                [0.5183, 0.0367],
                [0.75, 0],
                [0.9818, 0.0367],
                [1.1909, 0.1433],
                [1.3568, 0.3092],
                [1.4633, 0.5183],
                [1.5, 0.75],
                [1.5, 0.75],
              ],
              i: [
                [0, 0],
                [0.0243, -0.0748],
                [0.0463, -0.0637],
                [0.0637, -0.0463],
                [0.0749, -0.0243],
                [0.0787, 0],
                [0.0749, 0.0243],
                [0.0637, 0.0463],
                [0.0463, 0.0637],
                [0.0243, 0.0749],
                [0, 0.0787],
                [-0.0243, 0.0749],
                [-0.0463, 0.0637],
                [-0.0637, 0.0463],
                [-0.0748, 0.0243],
                [-0.0787, 0],
                [-0.0748, -0.0243],
                [-0.0637, -0.0463],
                [-0.0463, -0.0637],
                [-0.0243, -0.0748],
                [0, -0.0787],
                [0, 0],
              ],
              o: [
                [0, 0.07869999999999999],
                [-0.02429999999999999, 0.07489999999999997],
                [-0.04630000000000001, 0.06370000000000009],
                [-0.06370000000000009, 0.04630000000000001],
                [-0.07479999999999998, 0.02429999999999999],
                [-0.07869999999999999, 0],
                [-0.07479999999999998, -0.02429999999999999],
                [-0.0637, -0.04630000000000001],
                [-0.04630000000000001, -0.06370000000000009],
                [-0.0243, -0.07479999999999998],
                [0, -0.07869999999999999],
                [0.024299999999999995, -0.07479999999999998],
                [0.04630000000000001, -0.0637],
                [0.06370000000000003, -0.04630000000000001],
                [0.07489999999999997, -0.0243],
                [0.07869999999999999, 0],
                [0.07489999999999997, 0.024299999999999995],
                [0.06370000000000009, 0.04630000000000001],
                [0.04630000000000001, 0.06370000000000003],
                [0.02429999999999999, 0.07489999999999997],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [1, 0.7019607843137254, 0.34901960784313724] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      ef: [],
      tt: 1,
    },
    {
      ty: 3,
      ddd: 0,
      ind: 22818,
      hd: false,
      nm: 'Ellipse 10 - Null',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0.75, 0.75] },
        o: {
          a: 1,
          k: [
            { t: 13.8, s: [100], o: { x: [0.5], y: [0] }, i: { x: [0.5], y: [1] } },
            { t: 25.200000000000003, s: [0] },
          ],
        },
        p: {
          a: 1,
          k: [
            {
              t: -8.7,
              s: [13.25, 9.5833],
              o: { x: [0.5], y: [0] },
              i: { x: [0.5], y: [1] },
              ti: [0, 0],
              to: [0, 0],
            },
            { t: 25.2, s: [13.25, -1.92] },
          ],
        },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 77235,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 18996,
      hd: false,
      nm: 'Ellipse 10',
      parent: 22818,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            { t: 13.8, s: [100], o: { x: [0.5], y: [0] }, i: { x: [0.5], y: [1] } },
            { t: 25.200000000000003, s: [0] },
          ],
        },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [1.5, 0.75],
                [1.4633, 0.9818],
                [1.3568, 1.1909],
                [1.1909, 1.3568],
                [0.9818, 1.4633],
                [0.75, 1.5],
                [0.5183, 1.4633],
                [0.3092, 1.3568],
                [0.1433, 1.1909],
                [0.0367, 0.9818],
                [0, 0.75],
                [0.0367, 0.5183],
                [0.1433, 0.3092],
                [0.3092, 0.1433],
                [0.5183, 0.0367],
                [0.75, 0],
                [0.9818, 0.0367],
                [1.1909, 0.1433],
                [1.3568, 0.3092],
                [1.4633, 0.5183],
                [1.5, 0.75],
                [1.5, 0.75],
              ],
              i: [
                [0, 0],
                [0.0243, -0.0748],
                [0.0463, -0.0637],
                [0.0637, -0.0463],
                [0.0749, -0.0243],
                [0.0787, 0],
                [0.0749, 0.0243],
                [0.0637, 0.0463],
                [0.0463, 0.0637],
                [0.0243, 0.0749],
                [0, 0.0787],
                [-0.0243, 0.0749],
                [-0.0463, 0.0637],
                [-0.0637, 0.0463],
                [-0.0748, 0.0243],
                [-0.0787, 0],
                [-0.0748, -0.0243],
                [-0.0637, -0.0463],
                [-0.0463, -0.0637],
                [-0.0243, -0.0748],
                [0, -0.0787],
                [0, 0],
              ],
              o: [
                [0, 0.07869999999999999],
                [-0.02429999999999999, 0.07489999999999997],
                [-0.04630000000000001, 0.06370000000000009],
                [-0.06370000000000009, 0.04630000000000001],
                [-0.07479999999999998, 0.02429999999999999],
                [-0.07869999999999999, 0],
                [-0.07479999999999998, -0.02429999999999999],
                [-0.0637, -0.04630000000000001],
                [-0.04630000000000001, -0.06370000000000009],
                [-0.0243, -0.07479999999999998],
                [0, -0.07869999999999999],
                [0.024299999999999995, -0.07479999999999998],
                [0.04630000000000001, -0.0637],
                [0.06370000000000003, -0.04630000000000001],
                [0.07489999999999997, -0.0243],
                [0.07869999999999999, 0],
                [0.07489999999999997, 0.024299999999999995],
                [0.06370000000000009, 0.04630000000000001],
                [0.04630000000000001, 0.06370000000000003],
                [0.02429999999999999, 0.07489999999999997],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [1, 0.34901960784313724, 0.34901960784313724] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      ef: [],
      tt: 1,
    },
    {
      ty: 3,
      ddd: 0,
      ind: 51802,
      hd: false,
      nm: 'Ellipse 9 - Null',
      parent: 13506,
      ks: {
        a: { a: 0, k: [1, 1] },
        o: {
          a: 1,
          k: [
            {
              t: 8.399999999999991,
              s: [100],
              o: { x: [0.5], y: [0] },
              i: { x: [0.5], y: [1] },
            },
            { t: 32.39999999999999, s: [0] },
          ],
        },
        p: {
          a: 1,
          k: [
            {
              t: 1.5,
              s: [5.3333, 11],
              o: { x: [0.5], y: [0] },
              i: { x: [0.5], y: [1] },
              ti: [0, 0],
              to: [0, 0],
            },
            { t: 40.19999999999999, s: [5.33, -1] },
          ],
        },
        r: { a: 0, k: 0 },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 51680,
      hd: false,
      nm: 'ic-flame_sm - Mask',
      parent: 13506,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [0, 20],
                [0, 0],
                [20, 0],
                [20, 20],
                [0, 20],
              ],
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [0, 1, 0] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      td: 1,
    },
    {
      ty: 4,
      ddd: 0,
      ind: 92212,
      hd: false,
      nm: 'Ellipse 9',
      parent: 51802,
      ks: {
        a: { a: 0, k: [0, 0] },
        p: { a: 0, k: [0, 0] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            {
              t: 8.399999999999991,
              s: [100],
              o: { x: [0.5], y: [0] },
              i: { x: [0.5], y: [1] },
            },
            { t: 32.39999999999999, s: [0] },
          ],
        },
      },
      st: 0,
      ip: 0,
      op: 45,
      bm: 0,
      shapes: [
        {
          ty: 'sh',
          nm: 'Path',
          hd: false,
          ks: {
            a: 0,
            k: {
              c: true,
              v: [
                [2, 1],
                [1.9511, 1.309],
                [1.809, 1.5878],
                [1.5878, 1.809],
                [1.309, 1.9511],
                [1, 2],
                [0.691, 1.9511],
                [0.4122, 1.809],
                [0.191, 1.5878],
                [0.0489, 1.309],
                [0, 1],
                [0.0489, 0.691],
                [0.191, 0.4122],
                [0.4122, 0.191],
                [0.691, 0.0489],
                [1, 0],
                [1.309, 0.0489],
                [1.5878, 0.191],
                [1.809, 0.4122],
                [1.9511, 0.691],
                [2, 1],
                [2, 1],
              ],
              i: [
                [0, 0],
                [0.0324, -0.0998],
                [0.0617, -0.0849],
                [0.0849, -0.0617],
                [0.0998, -0.0324],
                [0.1049, 0],
                [0.0998, 0.0324],
                [0.0849, 0.0617],
                [0.0617, 0.0849],
                [0.0324, 0.0998],
                [0, 0.1049],
                [-0.0324, 0.0998],
                [-0.0617, 0.0849],
                [-0.0849, 0.0617],
                [-0.0998, 0.0324],
                [-0.1049, 0],
                [-0.0998, -0.0324],
                [-0.0849, -0.0617],
                [-0.0617, -0.0849],
                [-0.0324, -0.0998],
                [0, -0.1049],
                [0, 0],
              ],
              o: [
                [0, 0.1049],
                [-0.032399999999999984, 0.09979999999999989],
                [-0.06170000000000009, 0.08489999999999998],
                [-0.08489999999999998, 0.06170000000000009],
                [-0.09979999999999989, 0.032399999999999984],
                [-0.1049, 0],
                [-0.0998, -0.032399999999999984],
                [-0.08489999999999998, -0.06170000000000009],
                [-0.061700000000000005, -0.08489999999999998],
                [-0.0324, -0.09979999999999989],
                [0, -0.1049],
                [0.0324, -0.0998],
                [0.06169999999999998, -0.08489999999999998],
                [0.08489999999999998, -0.061700000000000005],
                [0.0998, -0.0324],
                [0.1049, 0],
                [0.09979999999999989, 0.0324],
                [0.08489999999999998, 0.06169999999999998],
                [0.06170000000000009, 0.08489999999999998],
                [0.032399999999999984, 0.0998],
                [0, 0],
                [0, 0],
              ],
            },
          },
        },
        {
          ty: 'fl',
          o: { a: 0, k: 100 },
          c: { a: 0, k: [1, 0.5058823529411764, 0.34901960784313724] },
          nm: 'Fill',
          hd: false,
          r: 1,
        },
      ],
      ef: [],
      tt: 1,
    },
  ],
  meta: { a: '', d: '', tc: '', g: 'Aninix' },
};

export default function AnimationFlame(props: LottieProps) {
  return <LottieBase {...props} animationJSON={animationJSON} />;
}
